import { useMemo } from 'react';
import { randomBase32String } from 'js/utils/string';

export function useId() {
  const id = useMemo(() => {
    return 'id-' + randomBase32String(10);
  }, []);
  return id;
}
